import { useEffect, useState } from "react";
import client from "@/lib/api";
import { ExternalLink } from "lucide-react";
import { Combobox } from "@/components/form/Combobox";

export function ProcedurePicker({ value, onChange, testid = "task-field-procedure" }) {
  const [procs, setProcs] = useState([]);
  const [ticked, setTicked] = useState(Boolean(value));
  useEffect(() => { if (value) setTicked(true); }, [value]);
  useEffect(() => { if (ticked && !procs.length) client.get("/procedures").then(({ data }) => setProcs(data)).catch(() => {}); }, [ticked]); // eslint-disable-line react-hooks/exhaustive-deps
  const opts = procs.map((p) => ({ value: p.id, label: p.category ? `${p.title} · ${p.category}` : p.title }));
  const toggle = (on) => { setTicked(on); if (!on && value) onChange(null); };
  return (
    <div data-testid={testid}>
      <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
        <input type="checkbox" data-testid={`${testid}-toggle`} checked={ticked} onChange={(e) => toggle(e.target.checked)}
          className="h-4 w-4 rounded border-slate-300 text-sky-600 focus:ring-sky-500" />
        Link To Procedure
      </label>
      {ticked && (
        <div className="mt-2 flex items-center gap-2">
          <div className="min-w-0 flex-1"><Combobox value={value || null} onChange={(v) => onChange(v || null)} options={opts} placeholder="Search procedures…" testid={`${testid}-select`} /></div>
          {value && (
            <a href={`/procedures/${value}`} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-view`}
              className="flex shrink-0 items-center gap-1 rounded-lg bg-sky-50 px-2.5 py-2 text-xs font-semibold text-sky-700 hover:bg-sky-100">
              <ExternalLink className="h-3.5 w-3.5" />View procedure
            </a>
          )}
        </div>
      )}
    </div>
  );
}
